import styled from "styled-components";

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin-top: 40px;
`;

export const Logo = styled.img`
  width: 40px;
  height: 40px;
`;
